import { CardTransactionDTO, Res } from 'core/api';
import { Result } from 'core/infrastructure';
import { CardTransactionMetadata, Cordova } from 'pos/common';
import { Pinpad } from './Pinpad';
import { Message } from 'core/ui-next/modal';
import { ProcessDialog } from 'pos/ui';

const pinpad: Pinpad = {

	async transact(transactionId: string, amount: number, metadata: CardTransactionMetadata): Promise<Result<CardTransactionDTO>> {
		const isRefund = amount < 0;
		const isReferencedRefund = isRefund && metadata.relatedTransactionXmlDetails?.length > 0;
		return await ProcessDialog.showWhile({
			title: Res.Msg.MSG_PROCESSING_PAYMENT_DIALOG_TITLE(),
			msg: isRefund ? Res.Msg.MSG_PROCESSING_REFUND_DIALOG_CONTENT() : Res.Msg.MSG_PROCESSING_PAYMENT_DIALOG_CONTENT(),
			action: async () => {
				try {
					const result = isRefund
						? (isReferencedRefund ? await Cordova.processRefund(amount, metadata) : await Cordova.processUnreferencedRefund(transactionId, amount, metadata))
						: await Cordova.processSale(transactionId, amount, metadata);
					return Result.ok(result);
				} catch (error) {
					await Message.show(Res.Msg.MSG_PAYMENT_OPERATION_NOT_COMPLETED(error));
					return Result.error();
				}
			}
		});
	}
};

export default pinpad;